import { api } from "./api";
import { EMS_SCHEMAS } from "./config";
import { schemaScript } from "./schemaFlip";

const CATALOGUE = EMS_SCHEMAS.map((s) => ({ ...s, script: schemaScript(s.name)?.script ?? "" }));

export async function suggestSchemas(data) {
  try {
    const { data: r } = await api.post("/ai/suggest-schemas", { catalogue: CATALOGUE, data }, { timeout: 60000 });
    return { schemas: r.schemas || [], reasons: r.reasons || {} };
  } catch {
    return { schemas: [], reasons: {} };
  }
}
